import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import {
  HiHome,
  HiUsers,
  HiShoppingCart,
  HiDocumentText,
  HiCube,
  HiUserGroup,
  HiChartBar,
  HiCog6Tooth,
  HiArrowRightOnRectangle,
  HiPhoto,
} from 'react-icons/hi2';
import { useAuth } from '../../contexts/AuthContext';

const navItems = [
  { icon: HiHome, label: 'Dashboard', to: '/admin', end: true },
  { icon: HiUsers, label: 'Customers', to: '/admin/customers' },
  { icon: HiShoppingCart, label: 'Orders', to: '/admin/orders' },
  { icon: HiDocumentText, label: 'Billing', to: '/admin/billing' },
  { icon: HiCube, label: 'Inventory', to: '/admin/inventory' },
  { icon: HiUserGroup, label: 'Employees', to: '/admin/employees' },
  { icon: HiChartBar, label: 'Reports', to: '/admin/reports' },
  { icon: HiPhoto, label: 'Gallery', to: '/admin/gallery' },
  { icon: HiCog6Tooth, label: 'Users', to: '/admin/users' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="app-layout">
      {/* Sidebar */}
      <aside className="sidebar">
        {/* Sidebar Brand */}
        <div
          style={{
            padding: '1.25rem 1rem',
            borderBottom: '1px solid rgba(255,255,255,0.07)',
            display: 'flex',
            alignItems: 'center',
            gap: '0.6rem',
          }}
        >
          <div style={{ background: 'white', borderRadius: '8px', padding: '4px 8px', display: 'inline-block' }}>
            <img src="/Vijaya_Varshi_Logo_V13.png" alt="Vijaya Varshi" style={{ height: 36, objectFit: 'contain', display: 'block' }} />
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '0.75rem 0' }}>
          <div className="nav-section">Main Menu</div>
          {navItems.map(({ icon: Icon, label, to, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Sidebar Footer */}
        <div
          style={{
            padding: '0.75rem',
            borderTop: '1px solid rgba(255,255,255,0.07)',
          }}
        >
          <button
            onClick={handleLogout}
            className="nav-item"
            style={{ width: '100%', background: 'none', border: 'none' }}
          >
            <HiArrowRightOnRectangle size={18} />
            Logout
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div className="main-content">
        {/* Topbar */}
        <header className="topbar">
          <div style={{ fontWeight: 700, fontSize: '1rem', color: '#0f172a' }}>
            Admin Panel
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '0.875rem', fontWeight: 600, color: '#0f172a' }}>
                {user?.name || 'Admin'}
              </div>
              <div style={{ fontSize: '0.75rem', color: 'var(--gray)' }}>Administrator</div>
            </div>
            <button
              onClick={handleLogout}
              className="btn btn-secondary btn-sm"
              style={{ gap: '0.35rem' }}
            >
              <HiArrowRightOnRectangle size={15} />
              Logout
            </button>
          </div>
        </header>

        {/* Page content */}
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
